export const ReportsTypes = [
    { label: "Arrival Bookings", value: "arrivalBookings", airports: ["A"] },
    { label: "Departures Bookings", value: "departuresBookings", airports: ["A"] },
    { label: "Passengers Record", value: "passengersRecord", airports: ["A"] },
    { label: "Arrival Forecast", value: "arrivalForecast", airports: ["A"] },
    { label: "Departures Forecast", value: "departuresForecast", airports: ["A"] },
    { label: "SLA Report", value: "SLAReport", airports: ["A"] },
    { label: "Airline Performance", value: "AirlinePerformanceReport", airports: ["A"] },
    { label: "Pre-Advised And Advanced", value: "preAdvisedAndAdvanced", airports: ["A"] },
    { label: "Reviews", value: "reviews", airports: ["A"] },
    { label: "Tasks", value: "tasks", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Comparison Report", value: "comparison", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA"] },
    { label: "Employee Conversations", value: "employeeConversations", airports: ["A"] },
    { label: "Flights Conversations", value: "flightsConversations", airports: ["A"] },
    { label: "Flight Report", value: "flightReport", airports: ["DUB", "EDI"] },
    { label: "Productivity Report", value: "productivityReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Employee Activity Report", value: "activityReport", airports: ["ORK", "DUB", "BFS"] },
    { label: "App Session Log", value: "AppSessionLog", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Portal Sessions", value: "portalSessions", airports: ["DUB"] },//
    { label: "Employees Breaks Log", value: "breaksReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Gate Changes Report", value: "gateChangesReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA"] },
    { label: "Vehicle Report", value: "vehicleReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA"] },
    { label: "Shifts", value: "shifts", airports: ["DUB", "BFS", "ORK", "PUJ", "EDI", "SNN"] },
    { label: "Third State Flights", value: "thirdStateFlights", airports: ["DUB"] },
    { label: "Device Report", value: "deviceReport", airports: ["DUB"] },//Comment this while no APK is released
    { label: "SunflowerLanyard Report", value: "sunflowerLanyard", airports: ["DUB"] },//Comment this while no APK is released
    { label: "Movement Report", value: "movementReport", airports: ["DUB"] },
];

export const BookingsTypes = [
    { label: "All Bookings", value: "none" },
    { label: "Portal", value: "P" },
    { label: "App", value: "A" },
    { label: "SITA", value: "S" },
    { label: "Connect API", value: "C" },

]

export const tasksType = [
    { label: "Total", value: "all" },
    { label: "Completed", value: "completed" },
    { label: "Assigned", value: "assigned" },


]

export const taskReportTypes = [
    { label: "All Task Types", value: "all" },
    { label: "Arrival", value: "arrival" },
    { label: "Departure", value: "departure" },
    { label: "Boarding", value: "boarding" },
    { label: "Transit", value: "transit" },
    { label: "Alt Pickup", value: "alt pickup" },
    { label: "Ramp", value: "ramp" },
    { label: "Flight Task", value: "flight task" },
    { label: "Self Allocated", value: "self allocated" },
    { label: "Grouped Self Allocated", value: "grouped self allocated" },
    { label: "Transferred", value: "transferred" },
]

export const preAdvisedAndNonPreAdvised = [
    "        ",
    "Pax Type",
    "Bookings",
    "Completed",
    "Percentage"
];

export const reviewsListTitles = [
    "     ",
    "Name",
    "flight Date",
    "flight",
    "Assistance quality",
    "Staff assistance",
    "Waiting Time",
    "Comments",
];


// STA - STANDARD TIME OF ARRIVAL (ARRIVAL ONLY)
// ACT - ACTUAL TIME OF ARRIVAL (DEPARTURE ONLY)
//SCHEDULE TIME OF DEPARTURE
export const taskColumnsTitles = [
    "Passenger Name",
    "Cat",
    "P adv Y/N",
    "FLT NO",
    "Arr/Dep",
    "Orig/DES",
    "STA",
    // "ACT",
    "STD",
    // "ATD"
    "Agent Name",
    "Task Type",
    "Equipment",
    "Alloc Time",
    "At Loc Time",
    "Start Time",
    "Job Fin",
    "Service Duration",
    "Task Notes"
]


export const airlines = [
    { label: "ALL", value: "" },

    { label: "FR – Ryanair", value: "FR" },
    { label: "EI – Aer Lingus", value: "EI" },
    { label: "TK – Turkish Airlines", value: "TK" },
    { label: "EK – Emirates", value: "EK" },
    { label: "AF – Air France", value: "AF" },
    { label: "BT – airBaltic", value: "BT" },
    { label: "DL – Delta", value: "DL" },
    { label: "BA – British Airways", value: "BA" },
    { label: "OU – Croatia Airlines", value: "OU" },
    { label: "XQ – SunExpress", value: "XQ" },
    { label: "VY – Vueling", value: "VY" },
    { label: "AA – American Airlines", value: "AA" },
    { label: "LH – Lufthansa", value: "LH" },
    { label: "UA – United Airlines", value: "UA" },
    { label: "EY – Etihad", value: "EY" },
    { label: "LX – Swiss", value: "LX" },
    { label: "LS – Jet2", value: "LS" },
    { label: "EZY – easyJet", value: "EZY" },
    { label: "SI – Blue Islands", value: "SI" },
    { label: "KL – KLM", value: "KL" },
    { label: "TUI – TUI", value: "TUI" },
    { label: "BY – TUI Airways", value: "BY" },
    { label: "TOM – TUI Airways", value: "TOM" },
    { label: "UL – SriLankan Airlines", value: "UL" },
    { label: "AC – Air Canada", value: "AC" },
    { label: "QR – Qatar Airways", value: "QR" },
    { label: "H4", value: "H4" },
    { label: "RK – Ryanair UK", value: "RK" },
    { label: "DY – Norwegian", value: "DY" },
    { label: "IB – Iberia", value: "IB" },
    { label: "AP – AlbaStar", value: "AP" },
    { label: "TP – TAP Air Portugal", value: "TP" },
    { label: "WS – WestJet", value: "WS" },
    { label: "VA – Virgin Australia", value: "VA" },
    { label: "2S", value: "2S" },
    { label: "3L – Air Arabia Abu Dhabi", value: "3L" },
    { label: "5K – Hi Fly", value: "5K" },
    { label: "8H – BH Air", value: "8H" },
    { label: "CL – Lufthansa CityLine", value: "CL" },
    { label: "E4 – Enter Air", value: "E4" },
    { label: "EA – Emerald Airlines", value: "EA" },
    { label: "FI – Icelandair", value: "FI" },
    { label: "LM – Loganair", value: "LM" },
    { label: "OG – PLAY", value: "OG" },
    { label: "OR – TUI fly Netherlands", value: "OR" },
    { label: "R6", value: "R6" },
    { label: "SR", value: "SR" },
    { label: "T3 – Eastern Airways", value: "T3" },
    { label: "T9", value: "T9" },
    { label: "TB – TUI fly Belgium", value: "TB" },
    { label: "TS – Air Transat", value: "TS" },
    { label: "V3", value: "V3" },
    { label: "W4 – Wizz Air Malta", value: "W4" },
    { label: "W6 – Wizz Air", value: "W6" },
    { label: "WG – Sunwing", value: "WG" },
    { label: "XC – Corendon Airlines", value: "XC" },
    { label: "YW – Air Nostrum", value: "YW" },
    { label: "5M", value: "5M" },
    { label: "6Y – SmartLynx", value: "6Y" },
    { label: "A3 – Aegean", value: "A3" },
    { label: "A5 – HOP!", value: "A5" },
    { label: "AY – Finnair", value: "AY" },
    { label: "D0 – DHL Air", value: "D0" },
    { label: "E6", value: "E6" },
    { label: "E9", value: "E9" },
    { label: "EE", value: "EE" },
    { label: "EW – Eurowings", value: "EW" },
    { label: "FH – Freebird Airlines", value: "FH" },
    { label: "FX – FedEx", value: "FX" },
    { label: "HU – Hainan Airlines", value: "HU" },
    { label: "HV – Transavia", value: "HV" },
    { label: "I2 – Iberia Express", value: "I2" },
    { label: "JO", value: "JO" },
    { label: "LW", value: "LW" },
    { label: "NO – Neos", value: "NO" },
    { label: "RC – Atlantic Airways", value: "RC" },
    { label: "RR", value: "RR" },
    { label: "SK – SAS", value: "SK" },
    { label: "SN – Brussels Airlines", value: "SN" },
    { label: "VS – Virgin Atlantic", value: "VS" },
    { label: "WK – Edelweiss", value: "WK" },
    { label: "WX – CityJet", value: "WX" },
    { label: "ZQ", value: "ZQ" },
    { label: "SV – Saudia", value: "SV" },
    { label: "6B – TUI fly Nordic", value: "6B" },
    { label: "ASL – ASL Airlines", value: "ASL" },
    { label: "5F – FlyOne", value: "5F" },
    { label: "B6 – JetBlue", value: "B6" },
    { label: "MH – Malaysia Airlines", value: "MH" },
    { label: "TG – Thai Airways", value: "TG" },
    { label: "KE – Korean Air", value: "KE" },
    { label: "GA – Garuda Indonesia", value: "GA" },
    { label: "NH – ANA", value: "NH" },
    { label: "VL", value: "VL" },
    { label: "AM – Aeromexico", value: "AM" },
    { label: "AR – Aerolíneas Argentinas", value: "AR" },
    { label: "RER", value: "RER" },
    { label: "TX – Air Caraïbes", value: "TX" },
    { label: "Y2 – Air Century", value: "Y2" },
    { label: "UX – Air Europa", value: "UX" },
    { label: "G4 – Allegiant Air", value: "G4" },
    { label: "DM – Arajet", value: "DM" },
    { label: "XP – Avelo Airlines", value: "XP" },
    { label: "AV – Avianca", value: "AV" },
    { label: "MX – Mexicana", value: "MX" },
    { label: "DE – Condor", value: "DE" },
    { label: "CM – Copa Airlines", value: "CM" },
    { label: "4Y – Discover Airlines", value: "4Y" },
    { label: "F9 – Frontier Airlines", value: "F9" },
    { label: "GX", value: "GX" },
    { label: "G3 – GOL", value: "G3" },
    { label: "JA – JetSMART", value: "JA" },
    { label: "LA – LATAM", value: "LA" },
    { label: "LP – LATAM Peru", value: "LP" },
    { label: "H2 – Sky Airline", value: "H2" },
    { label: "DO – Sky High", value: "DO" },
    { label: "WN – Southwest", value: "WN" },
    { label: "NK – Spirit", value: "NK" },
    { label: "SY – Sun Country", value: "SY" },
    { label: "SRD", value: "SRD" },
    { label: "P5 – Wingo", value: "P5" },
    { label: "WL", value: "WL" },
    { label: "2W – World2fly", value: "2W" },
    { label: "3P", value: "3P" },
    { label: "MS – EgyptAir", value: "MS" },
    { label: "DN", value: "DN" },
    { label: "F8 – Flair Airlines", value: "F8" },
    { label: "8C", value: "8C" },
    { label: "5X – UPS", value: "5X" },
    { label: "PC – Pegasus", value: "PC" },
    { label: "KK", value: "KK" },
    { label: "WF – Widerøe", value: "WF" },
    { label: "G6", value: "G6" },
    { label: "5R", value: "5R" },
];

export const airports =
    [
        {
            "value": "",
            "label": "All"
        },
        {
            "value": "DUB",
            "label": "Dublin Airport"
        },
        {
            "value": "ORK",
            "label": "Cork Airport"
        },
        {
            "value": "BFS",
            "label": "Belfast International Airport"
        },
        {
            "value": "EDI",
            "label": "Edinburgh Airport"
        },
        {
            "value": "BRS",
            "label": "Bristol Airport"
        },
        {
            "value": "ALC",
            "label": "Alicante Airport"
        },
        {
            "value": "RMU",
            "label": "Corvera Airport Murcia (RMU)"
        },
        {
            "value": "GLA",
            "label": "Glasgow Airport"
        },
        {
            "value": "SNN",
            "label": "Shannon Airport"
        },
        {
            "value": "SOU",
            "label": "Southampton Airport"
        },
        {
            "value": "JED",
            "label": "King Abdulaziz International Airport "
        },
        {
            "value": "RUH",
            "label": "King Khalid International Airport"
        },
        {
            "value": "CFN",
            "label": "Donegal Airport"
        },
        {
            "value": "MAN",
            "label": "Manchester Airport"
        },
        {
            "value": "BOS",
            "label": "Boston Airport"
        },
        {
            "value": "SYD",
            "label": "Sydney Airport"
        },
        {
            "value": "PER",
            "label": "Perth Airport"
        },
        {
            "value": "LHR",
            "label": "London Heathrow"
        },
        {
            "value": "BHX",
            "label": "Birmingham Airport"
        },
        {
            "value": "JER",
            "label": "Jersey Airport"
        },
        {
            "value": "BHD",
            "label": "Belfast City Airport"
        },
        {
            "value": "INV",
            "label": "Inverness Airport"
        },
        {
            "value": "AUH",
            "label": "Zayed International Airport"
        },
        {
            "value": "DOH",
            "label": "Hamad International Airport"
        },
        {
            "value": "MLA",
            "label": "Malta International Airport"
        }
    ];

export const reportsWithTotalCountHeader = ["passengersRecord", "arrivalBookings", "departuresBookings", "employeeConversations"]
export const reportsWithAirlineFilter = ["AirlinePerformanceReport", "departuresBookings", "arrivalBookings", "passengersRecord"]

export const productivityReportTitles = [
    "Employee Name",
    "Employee Role",
    "Number of Sessions",
    "Total Passengers Assigned",
    "Total Passengers Started",
    "Total Flights Assigned",
    "Total Flights Started",
    "Productivity (Passengers)",
    "Productivity (Flights)",
];

export const productivityReportKeys = [
    "employeeName",
    "employeeRole",
    "sessions",
    "passengersAssigned",
    "passengersStarted",
    "flightsAssigned",
    "flightsStarted",
    "productivityPassengers",
    "productivityFlights",
];

// Employee Activity Report — one row per activity, grouped by employee app session.
// A "Session" row heads each group with its summary.
export const activityReportTitles = [
    "Date",
    "Employee Name",
    "Employee Role",
    "Session",
    "Type",
    "Activity",
    "Task Type",
    "Flight Date",
    "Pax",
    "Allocated",
    "Confirmed",
    "At Location",
    "Start",
    "Finish",
    "Duration (min)",
];

export const appSessionLogTitles = [
    "Employee Name",
    "Employee Role",
    "Email",
    "Date",
    "Log in Time",
    "Log Out Time",
    "Time Active",
    "Shift Start Location",
    "Shift End Location",
    "Shift Start Verification",
    "Shift End Verification",
    "Shift Start Proof",
    "Shift End Proof",
    "Device",
    "Device ID",
];

export const appSessionLogKeys = [
    "employeeName",
    "employeeRole",
    "email",
    "date",
    "logInTime",
    "logOutTime",
    "timeActive",
    "loginLocation",
    "logoutLocation",
    "loginLocationVerified",
    "logoutLocationVerified",
    "loginProof",
    "logoutProof",
    "device",
    "deviceLabel", // physical label, falls back to the raw device ID
];

// Portal (web) sessions never carry a shift QR scan, so they use the same
// columns as the app session log minus the location columns.
export const portalSessionsTitles = [
    "Employee Name",
    "Employee Role",
    "Email",
    "Date",
    "Log in Time",
    "Log Out Time",
    "Time Active",
];

export const portalSessionsKeys = [
    "employeeName",
    "employeeRole",
    "email",
    "date",
    "logInTime",
    "logOutTime",
    "timeActive",
];

export const shiftsReportTitles = [
    "Employee Name",
    "Employee Role",
    "Date",
    "Shift Start",
    "Shift End",
    "Time Active",
];

export const shiftsReportKeys = [
    "employeeName",
    "employeeRole",
    "date",
    "shiftStart",
    "shiftEnd",
    "timeActive",
];

export const breaksReportTitles = [
    "Date",
    "Employee Name",
    "Employee Role",
    "Break Start Time",
    "Break Finish Time",
];

export const breaksReportKeys = [
    "date",
    "employeeName",
    "employeeRole",
    "breakStartTime",
    "breakEndTime",
];

export const gateChangesReportTitles = [
    "Date",
    "Flight Number",
    "Gate Change From",
    "Gate Change To",
    "Time of Change",
    "PRM Pax Affected",
];

export const gateChangesReportKeys = [
    "date",
    "flightNumber",
    "originalGate",
    "currentGate",
    "changeTime",
    "paxAffected",
];

export const deviceReportTitles = [
    "Device Alias",
    "Device ID",
    "Model",
    "Last Known Employee",
    "Last Login Time",
];

export const deviceReportKeys = [
    "deviceAlias",
    "deviceId",
    "model",
    "lastKnownEmployee",
    "lastLoginTime",
];

export const vehicleReportTitles = [
    "Date",
    "Vehicle Alias",
    "Employee Name",
    "Last Active"
];

export const vehicleReportKeys = [
    "date",
    "vehicleAlias",
    "employeeName",
    "lastActive"
];

export const thirdStateFlightsReportTitles = [
    "Flight Number",
    "Origin Airport",
    "Flight Date",
    "Gate",
    "Stand",
    "Terminal",
    "Check-in Zone",
    "Aircraft Type",
    "Time",
    "Ambilift Type",
    "Operating Status",
    "Passenger Count",
    "Seat Capacity",
    "Flight Key",
    "Airbridge Used",
];

export const thirdStateFlightsReportKeys = [
    "flightNumber",
    "departureAirport",
    "flightDate",
    "gate",
    "stand",
    "terminal",
    "checkinZone",
    "aircraftType",
    "operationInfoTime",
    "ambiliftType",
    "operatingStatus",
    "passengerCount",
    "seatCapacity",
    "flightKey",
    "isAirbridgeUsed",
];

export const sunflowerReportTitles = [
    "Date Sold",
    "Airport",
    "Type",
    "Quantity",
    "Amount (€)",
    "Passenger",
    "Email",
    "Reference",
    "Flight",
    "Departure Date",
    "Status",
    "Transaction ID",
];

export const sunflowerReportKeys = [
    "dateSold",
    "airport",
    "type",
    "quantity",
    "revenue",
    "name",
    "email",
    "referenceNumber",
    "flight",
    "departureDate",
    "status",
    "transactionId",
];

export const REPORTS_WITHOUT_LIMITED_DATE_RANGE = ["sunflowerLanyard", "reviews"]